"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["charts"],

  data: function data() {
    return {
      activeChart: ""
    };
  },


  computed: {
    testCharts: function testCharts() {
      return _.omit(this.charts, "descriptions");
    },
    descriptions: function descriptions() {
      return this.charts.descriptions || [];
    },
    noTests: function noTests() {
      return this.testCharts && Object.keys(this.testCharts).length === 0;
    }
  },

  methods: {
    activateChart: function activateChart(name) {
      this.activeChart = this.activeChart === name ? "" : name;
    },


    /**
     * Get chart name
     * @param chart
     * @returns {*|string}
     */
    getChartName: function getChartName(chart) {
      return chart.name ? chart.name : "";
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/dashboard/ChartList.vue
// module id = 4NjT
// module chunks = 0 1